import React, { useReducer } from 'react';

const GlobalStateContext = React.createContext({});

export const { Provider, Consumer } = GlobalStateContext;

const initialState = {
    isAutoFeedbackGeneratorPollingBlocked: false,
};

export const ACTION_TYPES = {
    SET_IS_NEED_TO_RUN_GENERATOR_BEFORE_CANDIDATES_FETCH_FLAG: 1,
    SET_AUTO_FEEDBACK_GENERATOR_BLOCK_STATE: 2,

};

const reducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.SET_AUTO_FEEDBACK_GENERATOR_BLOCK_STATE:
            return {
                ...state,
                isAutoFeedbackGeneratorPollingBlocked: action.payload,
            };
        default:
            throw new Error('[AppWithGlobalState] Unknown reducer action type');
    }
};

export const AppWithGlobalState = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <Provider value={{
            globalState: state,
            dispatch,
        }}>
            {children}
        </Provider>
    );
};

export default GlobalStateContext;
